export const getComponentForContentType = (contentType, suffix) => {
  let component = 'image'

  if (contentType == 'application/pdf') {
    component = 'document'
  }

  return `mct-${component}-${suffix}`
}
